import AlloyWheelScratch from './Alloy_Wheel_Scratch.jpg';
import AlloyWheelScuff from './Alloy_Wheel_Scuff.jpg';
import AlloyWheelCorroded from './Alloy_Wheel_Corroded.jpg';
import AlloyWheelDistance from './Alloy_Wheel_Distance.jpg';
import AlloyWheelCloseup from './Alloy_Wheel_Closeup.jpg';
import AlloyWheelCracked from './Alloy_Wheel_Cracked.jpg';
import AlloyWheelBuckled from './Alloy_Wheel_Buckled.jpg';

const Images = {
    AlloyWheelScratch,
    AlloyWheelScuff,
    AlloyWheelCorroded,
    AlloyWheelCracked,
    AlloyWheelBuckled,
    AlloyWheelDistance,
    AlloyWheelCloseup
};

export default Images;
